import Vue from 'vue';
import 'libs/vue-extensions';
import MediaViewer from 'libs/components/media-viewer/viewer.vue';

export default class {
  constructor(parentId = 'body') {
    let $container = $(parentId);
    let div = document.createElement('div');
    div.className = 'modal fade';
    div.style.display = 'none';

    let mountDiv = document.createElement('div');
    mountDiv.id = 'portfolio_viewer_mount';
    div.appendChild(mountDiv);

    $container.append(div);
    this.$portfolioModal = $(div);
  }

  show(data, componentData = {}, events = {}) {
    let args = $.extend(true, {}, data, {
      navigation: {
        referrer: {
          action: () => {
            this.$portfolioModal.modal('hide');
            this.$portfolioModal.on('hidden.bs.modal', (e) => {
              this.$portfolioModal.remove();
            });
          }
        }
      }
    });

    if (args.work.shareable !== false) {
      args = $.extend(true, {}, args, {
        work: {
          shareable: {
            email_callback: (item) => {
              new Kadenze.AjaxRequest({
                type: 'POST',
                url: item.work.share_email_url,
                data: {emails: item.emails}
              });
            }
          }
        }
      });
    }

    const propsData = {args: args};
    const mediaViewer = Vue.extend(MediaViewer);
    const mvInstance = new mediaViewer({el: '#portfolio_viewer_mount', data: componentData, propsData: propsData, mounted: () => {
      this.$portfolioModal.modal('show');
    }});
    if (events.commentCountChanged && _.isFunction(events.commentCountChanged)) {
      mvInstance.$on('commentCountChanged', events.commentCountChanged);
    }
  }
}

